import { saveToStorage } from 'App/Helpers'
import {
	LOGOUT,
	RESET_ORGANIZATION_STATE,
	SET_ACTIVE,
	SET_SESSION,
	SET_USER,
	SET_VERSION,
} from './mutation-types'
import Application from 'App/Foundation/Application'
import { LOGIN_TIMESTAMP_KEY } from '@/config/constants'
import intercom from '@/services/intercom'

/**
 * Export the Office Manager Vuex store plugin.
 *
 * @author Erik Galloway <egalloway@claruscare.com>
 */
export default store => {
	// Save the active partner id to local storage if it is not persisted
	if (store.state.partners.active && !localStorage.getItem('partner')) {
		saveToStorage('partner', store.state.partners.active)
	}

	store.subscribe(({ type, payload }) => {
		switch (type) {
			case `auth/${LOGOUT}`:
				intercom.shutdown('auth-logout')
				Application.getInstance().emit('partner:change', {
					leave: store.state.partners.active,
					subscribe: 0,
				})
				localStorage.removeItem('partner')
				localStorage.removeItem('session')
				localStorage.removeItem('user')
				localStorage.removeItem(LOGIN_TIMESTAMP_KEY)
				localStorage.removeItem('isCallNotesDropdownOpen')
				localStorage.removeItem('isHistoryDropdownOpen')

				store.dispatch('settings/stopOrganizationProfilePolling')
				store.commit(`settings/${RESET_ORGANIZATION_STATE}`)
				store.dispatch('calls/reset')
				store.dispatch('partners/reset')
				break

			case `auth/${SET_USER}`:
				saveToStorage('user', payload)
				if (
					payload?.id &&
					payload?.intercom_hash_web &&
					store.state.auth.session?.access_token
				) {
					intercom.bootIdentified(payload, 'auth-set-user')
				}
				break

			case `auth/${SET_SESSION}`:
				saveToStorage('session', payload)
				break

			case `auth/${SET_VERSION}`:
				saveToStorage('version', payload)
				break

			case `partners/${SET_ACTIVE}`:
				store.dispatch('settings/stopOrganizationProfilePolling')
				store.commit(`settings/${RESET_ORGANIZATION_STATE}`)
				store.dispatch('settings/syncOrganizationProfilePolling')
				store.dispatch('calls/reset')
				store.dispatch('pages/reset')
				store.dispatch('callTypes/reset')
				// store.dispatch('providers/reset')
				// store.dispatch('calendars/reset')
				store.dispatch('events/reset')
				store.dispatch('timeBlocks/reset')

				payload
					? saveToStorage('partner', payload)
					: localStorage.removeItem('partner')

				break
		}
	})
}
